<template>
    <vs-button color="success" type="filled" icon-pack="feather" icon="icon-download" class="w-full" @click="handleClick" :disabled="client == null">
        {{ $t('export') |capitalize }}
    </vs-button>
</template>

<script>
import { BASE_URL } from '@/urls.js'
export default {
    name:'ExportButton',
    props:{
        client:{
            type:[String,Number],
        },
    },
    methods:{
        handleClick(){
            const url = BASE_URL + `internal_api/bonus_reserve/export/${this.client}-1988_975A_h_sjaajh_wrq-wqotuOHT9_852`
            window.open(url)
        }
    }

}
</script>

<style></style>